<template>
    <div class="row">
        <div class="col-md-12" v-if="!next">
            <b-overlay
                :show="status === 'loading'"
            >
                <AssignedAccounts
                    :data="assignedCardAccoutns"
                    @next:page="getPaymentInfo"
                ></AssignedAccounts>
            </b-overlay>
        </div>
        <div class="col-md-6" v-else>
            <b-overlay
                :show="status === 'loading'"
            >
                <PaymentInfo
                    :data="assignedCardPaymentInfo"
                    :user="authUserInfo"
                    @back:page="backPaymentInfo"
                ></PaymentInfo>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AssignedAccounts from './_components/AssignedAccounts'
import PaymentInfo from './_components/PaymentInfo'
export default {
    components: {
        AssignedAccounts,
        PaymentInfo
    },
    props: {
        accounts: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data () {
        return {
            next: false
        }
    },
    computed: {
        ...mapGetters({
            authUserInfo: 'authUserInfo',
            status: '$_payment_card/status',
            assignedCardAccoutns: '$_payment_card/assignedCardAccoutns',
            assignedCardPaymentInfo: '$_payment_card/assignedCardPaymentInfo'
        })
    },
    methods: {
        ...mapActions({
            fetchAssignedCardPaymentInfo: '$_payment_card/fetchAssignedCardPaymentInfo'
        }),
        getPaymentInfo ({ projectIdxs, assignedIdxs }) {
            this.fetchAssignedCardPaymentInfo({ projectIdxs, assignedIdxs }).then(() => {
                this.next = true
            })
        },
        backPaymentInfo () {
            this.next = false
        }
    }
}
</script>

<style>

</style>
